<template>
  <popup-modal ref="popup">
    <div v-if="!formSent">
    <h2 class="title mb-4">{{ $t('contact.form.title') }}</h2>
      <div class="close-popup " @click="cancel">
        <div class="dashed-border"/>
        <img src="@/assets/images/icons/Icon_cancel.svg" alt="">
      </div>
    <p class="mb-4">{{ $t('contact.form.subtitle') }}</p>
        <p v-if="formProcessing" style="font-style: italic; color:orange">
        {{ t('form.processing') }}</p>
      <form @submit="submit">
      <p class="ml-4 mb-1">{{ $t('contact.form.email') }}</p>
        <p v-if="badEmail"
          style="font-style: italic; color:red">
          {{ $t('contact.form.error.email') }}
        </p>
      <input type="email" class="form-control contact-form-input"
             style="width: 70%"
             v-bind:class="{ error: badEmail }"
              v-model="email"
              :placeholder="$t('contact.form.email.placeholder')"
              required
              aria-label="email" aria-describedby="button-addon2"
              :disabled="formProcessing">
      <p class="mt-3 ml-4 mb-1">
        {{ $t('contact.form.message') }}</p>
      <textarea class="form-control contact-form-input" style="min-height: 10rem"
                v-model="message"
                required
                maxlength="1000"
                :placeholder="$t('contact.form.message.placeholder')"
                :disabled="formProcessing"></textarea>
      <p style="text-align: right; font-size: 12px; padding-top: 0.5rem">
        {{ message.length }}/1000</p>
        <vue-recaptcha   ref="invisibleRecaptcha"
        size="invisible" sitekey="6Ldp2lcgAAAAAJ1uPf6zRn1p2euXxtwsoWWJQEec">
        </vue-recaptcha>
      <div class="pb5 d-flex">
        <input type="submit"
               class="button"
               :value="$t('label.send')" v-bind:class="{ error: badEmail }"
               :disabled="formProcessing">
        <button class="button-outline ml-3">{{ $t('label.cancel') }}</button>
      </div>
      </form>
    </div>
    <div v-else>
      <h2 class="title">{{ $t('form.contact.thanks') }}</h2>
      <div class="close-popup " @click="cancel">
        <div class="dashed-border"/>
        <img src="@/assets/images/icons/Icon_cancel.svg" alt="">
      </div>
      {{ $t('form.contact.sent') }}
    </div>
  </popup-modal>
</template>

<script>
import HelperMixin from '@/mixins/helperMixin';
import { VueRecaptcha } from 'vue-recaptcha';
import { useI18n } from 'vue-i18n';
import axios from 'axios';
import qs from 'query-string';
import PopupModal from './PopupModal.vue';

export default {
  name: 'ContactForm',
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
  mixins: [HelperMixin],
  components: {
    PopupModal,
    VueRecaptcha,
  },
  data() {
    return {
      badEmail: null,
      email: null,
      message: '',
      formSubmitted: false,
      formProcessing: false,
      formSent: false,
    };
  },
  methods: {
    show() {
      this.message = '';
      this.badEmail = null;
      this.email = null;
      this.formSent = false;
      this.$refs.popup.open();
    },
    submit(e) {
      e.preventDefault();
      this.badEmail = null;
      if (!this.validateEmail(this.email)) {
        this.badEmail = this.$t('contact.form.error.email');
        return false;
      }
      this.formProcessing = true;
      axios.post('https://sister.seriousfactory.com/api/web/form/webrequest', qs.stringify(
        {
          first_name: 'unknown',
          last_name: 'unknown',
          email: this.email,
          message: this.message,
          type: 'vtstack_contact',
          language: this.$i18n.locale,
        },
      )).then((response) => {
        this.formSubmitted = true;
        this.response = JSON.stringify(response, null, 2);
        this.formProcessing = false;
        this.formSent = true;
        this.sleep(5);
        this.$refs.popup.fade();
        return true;
      });
      return true;
    },
    cancel() {
      this.$refs.popup.close();
    },
    sleep(time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
  },
};
</script>

<style scoped>
.title {
  font: normal normal bold 24px/33px Open Sans;
  letter-spacing: 0px;
  color: #FFA459;
  margin-right: 3rem;
}
</style>
